import ViewQuiltOutlinedIcon from "@mui/icons-material/ViewQuiltOutlined";
import { Box, Skeleton } from "@mui/material";
import HomeSegmentCard from "../HomeSegmentCard";
import HomeSegmentContent from "../HomeSegmentContent";
import HomeSegmentTitle from "../HomeSegmentTitle";

const ActivityFeedSegmentCardSkeleton = ({ showHomeSegmentTitle }) => {
  return (
    <HomeSegmentCard>
      {showHomeSegmentTitle && (
        <HomeSegmentTitle>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <ViewQuiltOutlinedIcon /> Canvas:
            <Skeleton
              variant="rounded"
              width={430}
              height={25}
              sx={{ backgroundColor: "#EBEBEB", mb: "4px" }}
            />
          </Box>
        </HomeSegmentTitle>
      )}

      <HomeSegmentContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 2
          }}
        >
          <Skeleton
            variant="rounded"
            width={120}
            height={25}
            sx={{ backgroundColor: "#EBEBEB", mb: "4px" }}
          />
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80%"
          }}
        >
          <Skeleton
            variant="circular"
            sx={{
              backgroundColor: "white",
              border: "5px solid white",
              boxShadow: "0 0 0 25px #EBEBEB",
              width: "220px",
              height: "220px"
            }}
          />
        </Box>
      </HomeSegmentContent>
    </HomeSegmentCard>
  );
};
ActivityFeedSegmentCardSkeleton.defaultProps = {
  showHomeSegmentTitle: true
};
export default ActivityFeedSegmentCardSkeleton;
